// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"eba-z","vrsnlCrossSiteLabel":"fba-z"};